const RegionType = {
	ROI: "ROI",
	TTW: "TTW",
	TZ: "TZ"
};
// TODO: Not sure where/how to structure this. I'm in a bubble!
RegionType.all = () => {
	return [RegionType.ROI, RegionType.TTW, RegionType.TZ];
};
export default RegionType;
